// 限制相关的配置

import { MB } from './size'

export const MAX_SUPPLIER_DELIVERY_COUNT = 400

export const ENABLE_ARMS = process.env.NODE_ENV === 'production'
// export const ENABLE_ARMS = false

// 询价单文件类型
export const XJ_ACCEPT_FILE_TYPE =
  '.png,.jpg,.jpeg,.gif,.bmp,.tiff,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar'
export const XJ_FILE_SIZE = 50 * MB
export const XJ_FILE_MAX_COUNT = 10

export const XJ_UPLOAD_OPTION = {
  maxCount: XJ_FILE_MAX_COUNT,
  maxSize: XJ_FILE_SIZE,
  maxSizeErrorText: '单个附件尺寸不能超过50mb，请拆分或压缩后上传',
  accept: XJ_ACCEPT_FILE_TYPE,
  multiple: true,
}
// 限制相关的配置

import { MB } from './size'

export const MAX_SUPPLIER_DELIVERY_COUNT = 400

export const ENABLE_ARMS = process.env.NODE_ENV === 'production'
// export const ENABLE_ARMS = false

// 询价单文件类型
export const XJ_ACCEPT_FILE_TYPE =
  '.png,.jpg,.jpeg,.gif,.bmp,.tiff,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar'
export const XJ_FILE_SIZE = 50 * MB
export const XJ_FILE_MAX_COUNT = 10

export const XJ_UPLOAD_OPTION = {
  maxCount: XJ_FILE_MAX_COUNT,
  maxSize: XJ_FILE_SIZE,
  maxSizeErrorText: '单个附件尺寸不能超过50mb，请拆分或压缩后上传',
  accept: XJ_ACCEPT_FILE_TYPE,
  multiple: true,
}
